import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { API } from '../context/AuthContext';
import { FileText, Clock, Eye, ArrowRight } from 'lucide-react';

export function ArticleCards({ context, excludeId, title = 'Z naszego bloga', limit = 4 }) {
  const [articles, setArticles] = useState([]);
  const BACKEND = process.env.REACT_APP_BACKEND_URL;

  useEffect(() => {
    const params = { limit };
    if (context) params.context = context;
    if (excludeId) params.exclude_id = excludeId;
    
    axios.get(`${API}/blog/related`, { params })
      .then(res => setArticles(res.data.articles))
      .catch(() => {});
  }, [context, excludeId, limit]);

  if (articles.length === 0) return null;

  return (
    <div className="mt-8 pt-6 border-t border-border/30" data-testid="related-articles">
      <div className="flex items-center justify-between mb-4">
        <h2 className="font-heading text-lg sm:text-xl font-bold text-white flex items-center gap-2">
          <FileText className="w-5 h-5 text-primary" />
          {title}
        </h2>
        <Link
          to="/blog"
          className="text-xs text-primary hover:text-primary/80 font-heading uppercase tracking-wider flex items-center gap-1 transition-colors"
          data-testid="see-all-articles"
        >
          Wszystkie <ArrowRight className="w-3 h-3" />
        </Link>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3">
        {articles.map(article => {
          const coverImg = article.cover_image_local
            ? `${BACKEND}${article.cover_image_local}`
            : article.cover_image_url;

          return (
            <Link
              key={article.id}
              to={`/blog/${article.slug}`}
              className="bg-card border border-border/40 hover:border-primary/30 transition-colors group overflow-hidden"
              data-testid={`related-article-${article.id}`}
            >
              {coverImg ? (
                <div className="h-28 bg-secondary overflow-hidden">
                  <img
                    src={coverImg}
                    alt={article.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                    loading="lazy"
                  />
                </div>
              ) : (
                <div className="h-28 bg-secondary flex items-center justify-center">
                  <FileText className="w-8 h-8 text-muted-foreground/20" />
                </div>
              )}
              <div className="p-3">
                <h3 className="text-sm font-heading font-bold text-white group-hover:text-primary transition-colors line-clamp-2 leading-tight">
                  {article.title}
                </h3>
                <div className="flex items-center gap-2 mt-2 text-[10px] text-muted-foreground">
                  <span className="flex items-center gap-0.5">
                    <Clock className="w-2.5 h-2.5" />
                    {new Date(article.created_at).toLocaleDateString('pl-PL')}
                  </span>
                  <span className="flex items-center gap-0.5">
                    <Eye className="w-2.5 h-2.5" />
                    {article.views}
                  </span>
                </div>
                {article.tags?.length > 0 && (
                  <div className="flex gap-1 flex-wrap mt-1.5">
                    {article.tags.slice(0, 2).map(tag => (
                      <span key={tag} className="text-[9px] px-1.5 py-0.5 bg-primary/10 text-primary/70 border border-primary/20">
                        {tag}
                      </span>
                    ))}
                  </div>
                )}
              </div>
            </Link>
          );
        })}
      </div>
    </div>
  );
}
